<script>
export default {
    name: 'DashboardTileNavigationArrow',
    props: {
        route: {
            type: String,
            required: true,
        },
    },
};
</script>

<template>
<!--TODO: Link should't span across whole screen -->
<router-link class="tile-navigation" :to="route">
    <span>Hinzufügen</span>
</router-link>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.tile-navigation {
    display: flex;
    align-items: center;
    color: $orange;
    font-size: 18px;

    .icon-back {
        height: 26px;
        width: 26px;
        margin-left: 8px;
    }
}
</style>
